import { UseCase } from "../api/models";

export const DEFAULT_USE_CASE = "default";
export const DEFAULT_USE_CASE_NAME = "Default";
export const USE_CASE_FOLDER_LABELS = {
  default: "INTPA Virtual Library",
  finance_and_contract: "Legal and Finance",
  inequality_marker: "INTPA Virtual Library",
} as const;

export const USE_CASE_FOLDER_FILTERS = {
  default: null, // Show all folders
  finance_and_contract: "17. Financial and legal", // Only show folders under this path
  inequality_marker: null,
} as const;

export const USE_CASES: UseCase[] = [
  {
    name: "Finance and Legal Analysis",
    description:
      "Structured analysis of financial and legal aspects in line with INTPA contractual and regulatory framework.",
    id: "finance_and_contract",
    requirements:
      "Works best for queries on INTPA contractual and financial procedures.",
    confirmationMessage:
      "*Please ask me any question related to INTPA financial and/or contractual matters.*",
  },
  {
    name: "Global Gateway - EU Companies screening",
    description:
      "Identification and assessment of EU companies for participation in Global Gateway projects.",
    id: "eu_company",
    requirements: "Requires project context and clear selection criteria.",
    confirmationMessage:
      "*This workflow helps you identify EU companies potentially suitable for your Global Gateway project.*\n\n" +
      "*To begin, please provide the following information:*\n\n" +
      "*• Country or region of implementation*  \n" +
      "*• Type of project (sector, infrastructure, services, etc.)*  \n" +
      "*• Expected timeline (short / medium / long term)*  \n" +
      "*• Type of company required (SME, large corporation, technical expertise, etc.)*\n\n" +
      "*You may provide additional context if relevant.*\n\n" +
      "*Based on your input, I will:*\n\n" +
      "*1. Identify EU companies potentially capable of delivering the requested services.*  \n" +
      "*2. Provide a structured summary for each company.*  \n" +
      "*3. Prepare a consolidated overview with key findings and a recommendation.*\n\n" +
      "*Please provide the requested information to proceed.*",
  },
  {
    name: "Inequality Marker Assessment",
    description:
      "Structured step-by-step assessment and revision of a draft Action Document to ensure compliance with the INTPA Inequality Marker.",
    id: "inequality_marker",
    requirements: "Requires draft Action Document upload",
    confirmationMessage:
      "*This structured workflow will assess and, where necessary, strengthen your Action Document to ensure compliance with the European Commission Inequality Marker (I-Marker).*\n\n" +
      "*Before starting, please:*\n\n" +
      "*• Upload your Action Document in Word format*  \n" +
      "*• Indicate the intended I-Marker level (I-0, I-1, or I-2)*\n\n" +
      "*Example: I-2*\n\n" +
      "*What this workflow will do:*\n\n" +
      "*Step 1 – Section 2.1 Context*  \n" +
      "*Review and strengthen the analysis of trends and drivers of inequalities in the country and sector of intervention.*\n\n" +
      "*Step 2 – Section 2.2 Problem Analysis*  \n" +
      "*Assess whether the problem analysis adequately identifies and targets the bottom 40% and other socio-economically disadvantaged groups.*\n\n" +
      "*Step 3 – Section 3.1 Objectives and Expected Outputs*  \n" +
      "*Ensure that inequality reduction is properly reflected in the general and specific objectives and outputs.*\n\n" +
      "*Step 4 – Section 3.2 Indicative Activities*  \n" +
      "*Align activities with the revised objectives to ensure inequality reduction is operationalised in practice.*\n\n" +
      "*Step 5 – Section 3.3 Mainstreaming*  \n" +
      '*Create or revise the "Reduction of Inequalities" subsection and justify the selected I-Marker score.*\n\n' +
      "*Step 6 – Section 3.4 Risks and Lessons Learnt*  \n" +
      "*Identify inequality-related risks and propose proportionate mitigation measures.*\n\n" +
      "*Step 7 – Section 3.6 Logical Framework*  \n" +
      "*Revise or propose indicators to ensure measurable tracking of inequality reduction.*\n\n" +
      "*Step 8 – Section 5.1 Monitoring and Reporting*  \n" +
      "*Strengthen monitoring provisions to ensure inequality considerations are systematically tracked.*\n\n" +
      "*Step 9 – Section 5.2 Evaluation*  \n" +
      "*Ensure the evaluation framework assesses the distributional impact of the Action.*\n\n" +
      "*Based on the outputs of each step, I will provide a concise justification of the recommended score and guidance for completing the Action Summary Table.*\n\n" +
      "*I will then compile all proposed revisions and recommendations into a structured document.*\n\n" +
      "*Once you upload the document and indicate the intended I-Marker level, I will confirm the title and proceed with Step 1.*",
  },
  {
    name: DEFAULT_USE_CASE_NAME,
    id: DEFAULT_USE_CASE,
  },
];

export const TEXTS = {
  more_use_cases: "Explore additional use cases",
};
